import { Queue } from '@dygc/shared'

let Xlsx

const queue = new Queue()

function getXlsx(cb) {
  if (!Xlsx) {
    if (!queue.getIsRunning()) {
      queue.use(initialXlsx)
      queue.use(xlsx => {
        Xlsx = xlsx
      })
    }
    queue.use(() => {
      cb(Xlsx)
    })
    queue.run()
  } else {
    cb(Xlsx)
  }
}

function initialXlsx() {
  return import('xlsx')
}

function sheet2Blob(workbook) {
  // 生成excel的配置项
  let opts = {
    bookType: 'xlsx', // 要生成的文件类型
    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
    type: 'binary'
  }
  let res = Xlsx.write(workbook, opts)

  // 字符串转ArrayBuffer
  function s2ab(s) {
    let buf = new ArrayBuffer(s.length)
    let view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }

  return new Blob([s2ab(res)], { type: 'application/octet-stream' })
}

export function downloadXlsx(sheetList = [], option = {}) {
  getXlsx(Xlsx => {
    const wb = Xlsx.utils.book_new()
    if (option['!cols']) {
      wb['!cols'] = option['!cols']
    }

    sheetList.forEach((sheetAry, index) => {
      let sheet = Xlsx.utils.aoa_to_sheet(sheetAry)
      if (option['!cols']) {
        sheet['!cols'] = option['!cols']
      }
      Xlsx.utils.book_append_sheet(wb, sheet, `格式${index + 1}`)
    })
    const blob = sheet2Blob(wb)
    let url = URL.createObjectURL(blob)
    const aLink = document.createElement('a')
    aLink.href = url
    aLink.download = option.filename + '.xlsx' || ''
    aLink.click()
    URL.revokeObjectURL(url)
  })
}

/**
 *
 * @param file
 * @param {(WorkBook)=>void}cb
 */
export function readXlsx(file, cb) {
  getXlsx(Xlsx => {
    const reader = new FileReader()
    reader.onload = function (e) {
      let data = e.target.result
      let workbook = Xlsx.read(data, { type: 'binary' })
      cb && cb(workbook)
    }
    reader.readAsBinaryString(file)
  })
}
